var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floor-search",class:{gray: _vm.gray}},[_c('div',{staticClass:"container clearfix"},[_c('div',{staticClass:"logo-wrap"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"icon-logo",attrs:{"src":"//s1.huishoubao.com/static/pc/1001/img/logo.png"}})])],1),_vm._v(" "),_c('SearchForm')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a7322c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/projects/hsbpc/components/logo-search/index.vue
// module id = null
// module chunks = 